var map = {
	"./angle-down.svg": "NIH+",
	"./angle-left.svg": "NGcH",
	"./app-store.svg": "hLr0",
	"./arrow-right.svg": "LBJX",
	"./calendar.svg": "BZso",
	"./check.svg": "3KuU",
	"./chevron-down.svg": "+L5t",
	"./cross-eye.svg": "HyiL",
	"./cross.svg": "jQxW",
	"./download.svg": "Z3LA",
	"./edit.svg": "XRFS",
	"./eye.svg": "DweN",
	"./facebook.svg": "SNxX",
	"./filter.svg": "+AKO",
	"./globe.svg": "WutR",
	"./google-play-badge.svg": "K/86",
	"./info.svg": "bf//",
	"./instagram.svg": "u/lB",
	"./left-arrow.svg": "4Q4Z",
	"./linkedin.svg": "m+66",
	"./magnifying-glass.svg": "bmmY",
	"./menu.svg": "N3NX",
	"./right-arrow.svg": "reng",
	"./settings.svg": "SCLL",
	"./snapchat.svg": "2RRE",
	"./trash.svg": "GxAK",
	"./twitter.svg": "KeZa",
	"./user.svg": "muAW",
	"./youtube.svg": "u2r1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ogvf";